import React from 'react';
import type { ProfileGuardOptions } from '@link/share/utils';
import account, { Account } from './modules/account';
import auth, { Auth } from './modules/auth';
import cart, { Cart } from './modules/cart';
import product, { Product } from './modules/product';
import site, { Site } from './modules/site';

export type RootStore = {
  auth: Auth;
  account: Account;
  product: Product;
  site: Site;
  cart: Cart;
};

export const store: RootStore = {
  auth,
  account,
  product,
  site,
  cart
};

const StoreContext = React.createContext<RootStore>(store);

export const StoreProvider = StoreContext.Provider;

export const useStore = () => React.useContext(StoreContext);

// Post-auth profile-completeness gate wiring, shared by the Login and
// EmailVerification views.
export const profileGuard: ProfileGuardOptions = {
  accountStore: account,
  siteStore: site
};

export { auth, account, product, site, cart };
